import { I18n } from 'aws-amplify/utils';
import type { TFunction } from 'i18next';

export function getAmplifyLanguage(language: string | null | undefined) {
  return language?.startsWith('fr') ? 'fr' : 'en';
}

export function syncAmplifyLanguage(language: string | null | undefined) {
  I18n.setLanguage(getAmplifyLanguage(language));
}

export function amplifyTranslateImpl(key: string, defaultValue?: string) {
  const value = I18n.get(key);
  return typeof value === 'string' ? value : defaultValue ?? key;
}

export const amplifyTranslate = amplifyTranslateImpl as unknown as TFunction;
